module.exports = __webpack_public_path__ + "static/media/wChart.d8605ce3.png";